import * as React from 'react';
const AvatarContext = React.createContext({});
AvatarContext.displayName = 'Avatar.Context';
export function useAvatarContext() {
    return React.useContext(AvatarContext);
}
export function AvatarProvider(props) {
    const { children, isTruncated } = props;
    const contextValue = React.useMemo(() => {
        return { isTruncated };
    }, [isTruncated]);
    return (React.createElement(AvatarContext.Provider, { value: contextValue }, children));
}
//# sourceMappingURL=AvatarContext.js.map